module.exports = __webpack_public_path__ + "static/media/account-image-6.26e8053e.jpg";